export default {
  init() {

      $('.my-account-menu-icon').click( () => {
          $('.woocommerce-MyAccount-navigation').toggleClass('menu-open');
          return false;
      })
  },
};
